<template>
  <GestionNotificaciones />
</template>
<script>
import GestionNotificaciones from "./components/GestionNotificaciones.vue";
export default {
  name: "Notificaciones",
  components: { GestionNotificaciones }
};
</script>